import {Passport, Storage} from "../utils/Storage";
import {updateAssistantData, updatePassportData} from "../services/NetworkManager";
import {IProfileMood} from "../contexts/Auth/Auth";
import {Assistant} from "../API";

interface SaveToAwsParams {
    username: string;
    jwtToken: string;
    setProfileMoods: (moods: IProfileMood[]) => void;
    setPassportData: (data: Passport) => void;
}


interface SaveAssistantParams {
    username: string;
    jwtToken: string;
    setAssistantData: (data: Assistant) => void;
}

function isValidDate(dateString: string): boolean {
    if (!dateString) {
        return false;
    }

    const date = new Date(dateString);
    return !isNaN(date.getTime());
}


export async function savePassportToAws({
                                            setProfileMoods,
                                            setPassportData,
                                        }: SaveToAwsParams): Promise<void> {

    const data = await Storage.getStorage();
    const payload: any = {...data};

    if (payload.profile_dob && isValidDate(payload.profile_dob)) {
        payload.profile_dob = payload.profile_dob;
    } else {
        console.log("set profile_dob to null ")
        payload.profile_dob = null; // Explicitly overwrite with null
    }

    const response = await updatePassportData({
        ...payload
    });

    setProfileMoods(response.profile_mood || []);
    setPassportData(response);
}


export async function saveAssistantToAws({
                                            setAssistantData,

                                        }: SaveAssistantParams): Promise<void> {

    const data = await Storage.getStorage();
    const response = await updateAssistantData({
        ...data
    });

    setAssistantData(response);
}
